import styled, { css } from 'styled-components';

export const Wrapper = styled.section`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.regular};
    color: ${theme.v2.colors.neutral.lowDark};
    padding: 24px;
    min-width: auto;
    flex: 1;
    gap: 8px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      padding: 16px;
      gap: 8px;
    }
  `}
`;

export const SkeletonWrapper = styled(Wrapper)`

`;

export const Block = styled.div`
  ${({ theme }) => css`
    width: 100%;
    padding: 24px;
    border-radius: 16px;
    background-color: ${theme.v2.colors.white.primary};  

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      padding: 24px;
    }
  `}
`;

export const Header = styled(Block)`
  ${({ theme }) => css`
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
    gap: 8px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      
    }
  `}
`;

export const HeaderBackButton = styled.div`
  cursor: pointer;
`;

export const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px; 
`;

export const HeaderTitle = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.bold};
    color: ${theme.v2.colors.neutral.lowDark};

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.md};
    }      
  `}
`;

export const HeaderDescription = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    color: ${theme.v2.colors.neutral.lowDark};
    line-height: ${theme.v2.font.lineHeight.title};
    display: flex;
    flex-direction: column;
    gap: 16px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }

    p {
      margin: 0
    }
  `}
`;

export const CycleContainer = styled(Block)`
  ${({ theme }) => css`
    display: grid;
    grid-template-columns: 1fr 2fr 2fr;
    gap: 4px;

    @media (max-width: ${theme.breakpoints.md}) {
      display: flex;
      flex-direction: column;
    }
  `}
`;

export const CycleCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const CycleHeader = styled.div`

`;

export const CycleHeaderCol = styled.div`
  ${({ theme }) => css`
    padding: 24px;
    border-radius: 8px;
    gap: 24px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    background: ${theme.v2.colors.neutral.highLight};
  `}
`;

export const CycleHeaderSub = styled.span`
  ${({ theme }) => css`
    font-weight: ${theme.v2.font.weights.bold};
    font-size: ${theme.v2.font.sizes.xs};
    color: ${theme.v2.colors.neutral.lowDark};
    padding: 0;
    flex: 1;
  `}
`;

export const CycleBody = styled(CycleHeader)`

`;

export const CycleBodyCol = styled(CycleHeaderCol)`

`;

export const CycleBodySub = styled.span`
  ${({ theme }) => css`
    font-weight: ${theme.v2.font.weights.regular};
    font-size: ${theme.v2.font.sizes.xs};
    color: ${theme.v2.colors.neutral.lowDark};
    padding: 0;
    flex: 1;
  `}
`;

export const CycleColLast = styled(CycleCol)`
  display: flex;
  flex-direction: column;
`;

export const CycleHeaderLast = styled(CycleHeader)`
  flex: 0 0 auto;
`;

export const CycleHeaderColLast = styled(CycleHeaderCol)`
  ${({ theme }) => css`
    background: ${theme.v2.colors.brand.primaryUltraLight};
    height: 100%;
  `}
`;

export const CycleBodyLast = styled(CycleBody)`
    flex: 1;
`;

export const CycleBodyColLast = styled(CycleBodyCol)`
  ${({ theme }) => css`
    background: ${theme.v2.colors.brand.primaryUltraLight};
    height: 100%;
  `}
`;

export const ProductCycle = styled.div`
  ${({ theme }) => css`
    background: ${theme.v2.colors.neutral.highLight};
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
    border-radius: 16px;        
  `}
`;

export const ProductCycleUnify = styled(ProductCycle)`
  ${({ theme }) => css`
    background: ${theme.v2.colors.brand.primaryUltraLight};      
  `}
`;

export const ProductCycleName = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.medium};
    color: ${theme.v2.colors.neutral.lowDark};

    @media (max-width: ${theme.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xs};
    }
  `}
`;

export const ProductCycleInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;

export const ProductCycleInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

export const ProductCycleLabel = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xxxs};
    font-weight: ${theme.v2.font.weights.medium};
    color: ${theme.v2.colors.neutral.lowMedium};
    flex: 1;
  `}
`;

export const ProductCycleValue = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    color: ${theme.v2.colors.neutral.lowDark};
    flex: 1;
  `}
`;

export const FinancialSection = styled(Block)`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const FinancialTitle = styled.div`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.title};
    color: ${theme.v2.colors.neutral.lowDark};
  `}
`;

export const FinancialPaymentItems = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 24px 0;
  width: fit-content;
`;

export const FinancialPaymentItem = styled.li`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 0 72px;

    @media (max-width: ${theme.breakpoints.md}) {
      gap: 8px 0;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
    }
  `}
`;

export const FinancialPaymentText = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    color: ${theme.v2.colors.neutral.lowDark};
    line-height: ${theme.v2.font.lineHeight.title};
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;    
    gap: 0 4px;

    @media (max-width: ${theme.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;

export const FinancialPaymentValue = styled.strong`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.bold};
    color: ${theme.v2.colors.neutral.lowDark};
    line-height: ${theme.v2.font.lineHeight.title};

    @media (max-width: ${theme.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }    
  `}
`;

export const FinancialWarning = styled.div`
  ul {
    margin: 0;
    padding: 0 0 0 24px;
  }
`;

export const FinancialConfirmation = styled.div`
  display: flex;
  user-select: none;
  flex-direction: row;
  align-items: center;
`;

export const FinancialConfirmationCheckboxLabel = styled.label`
  ${({ theme }) => css`
    cursor: pointer;
    display: inline-flex;
    align-items: flex-start;
    margin: 0;

    button {
      padding: 2px 8px 0px 0px;
    }

    label {
      border-radius: 4px;
      border-width: 1px;
      width: 16px;
      height: 16px;      

      svg {
        fill: ${theme.v2.colors.neutral.highPure};
        stroke: ${theme.v2.colors.neutral.highPure};
        flex: 0 0 12px;
        border-radius: 4px;
      }
    }
    
    input:checked ~ label {
      background-color: ${theme.v2.colors.brand.primaryMedium};
      border-color: ${theme.v2.colors.brand.primaryMedium} !important;
    }
  `}
`;

export const FinancialConfirmationText = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    color: ${theme.v2.colors.neutral.lowDark};
    line-height: ${theme.v2.font.lineHeight.text};
    user-select: none;

    @media (max-width: ${theme.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }     
  `}
`;

export const FinancialButtons = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    gap: 24px;

    @media (max-width: ${theme.breakpoints.md}) {
      flex-direction: column;
      gap: 16px;
    }
  `}
`;
